class SingleFranchisesView extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.options = {
			isMobile : false,
			anchors : null
		}
	}

	init() {
		this.addEvents();
		setTimeout( ()=>{ this.defineOptions(); },300 );
	}

	addEvents() {
		$(window).on('scroll', ()=>{this.scrollHandler()});
		$(window).on('resize', ()=>{this.resizeHandler()});
		Me.dispatch.subscribe('breakpointChanged', (e, params)=>{this.breakpointHandler(e, params)});
	}

	removeEvents() {

	}

	defineOptions(){
		let navBarHeight     = $('.franchise-navigation').outerHeight();
		let navScrollHeight  = $('.section.header').outerHeight();
		let totalNavHeight   = navBarHeight + navScrollHeight;

		// Allows the data to be redefined only on the resize event instead of on both scroll and resize
		let scope = this;
		scope.options.anchors = null;
		this.$('section').each(function(i,val){

			if( $(val).attr('data-anchor') ) {
				if( scope.options.anchors == null ) {scope.options.anchors = []; }

				let offset = $(val).offset().top;
				let anchor = $(val).attr('data-anchor');
				let obj = {
					offset : offset - totalNavHeight,
					dataAnchor : anchor
				};
				scope.options.anchors.push(obj);
			}
		});
	}

	resizeHandler(){
		this.defineOptions();
		this.scrollHandler();
	}

	scrollHandler(){
		if(this.options.isMobile || this.options.anchors == null){
			return;
		}

		let currentScroll = $(document).scrollTop();

		// Checkes for the anchor that's he closest to the currentScroll
		let closestAnchor = null;
		this.options.anchors.forEach(function(anchor) {

			if(closestAnchor !== null){
				if(currentScroll >= anchor.offset && anchor.offset >= closestAnchor.offset){
					closestAnchor = anchor;
				}
			}else{
				closestAnchor = anchor;
			}

		});

		Me.dispatch.emit('navigation.focus', this, {activeSection : closestAnchor.dataAnchor});
	}

	breakpointHandler(e,params){
		if( params.breakpoint == '768-') {
			this.options.isMobile = true;
		}else{
			this.options.isMobile = false;
		}
	}
}

